import React from 'react';
import { useTranslation } from 'react-i18next';
import _get from 'lodash/get';
import Chart from 'react-apexcharts';
import { CounterMeasureGraphData } from 'graphql-common';
import Trans from '@lib/components/Trans/Trans';
import ListEmptyState from '@lib/components/ListEmptyState/ListEmptyState';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import CircleLoader from '@lib/components/CircleLoader/CircleLoader';
import WhiteBox from '@lib/components/WhiteBox/WhiteBox';
import mapDataToChart from './utils/mapDataToChart';

type Props = {
  data?: CounterMeasureGraphData[];
  loading?: boolean;
  onAddIndex: () => void;
};

export default function AssetCounterMeasuresGraphView(props: Props) {
  const { onAddIndex, data = [], loading } = props;
  const { t, i18n } = useTranslation();
  const locale = _get(i18n, 'language');

  const isEmpty = !data || data.length === 0;
  const chartData = mapDataToChart(data, t, locale);

  if (loading) {
    return <CircleLoader />;
  }

  if (isEmpty) {
    return (
      <ListEmptyState
        title={t('no-measures-yet')}
        text={<Trans i18nKey="no-measures-text" />}
        actions={[
          <Button
            key="add"
            leftIcon="add"
            buttonType={ButtonTypes.primaryFilled}
            buttonText={t('add-index')}
            onClick={onAddIndex}
            fullWidth
          />,
        ]}
      />
    );
  }

  return (
    <WhiteBox verticalPaddings="extraSmall" horizontalPaddings="small">
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="line"
        width="100%"
        height={350}
      />
    </WhiteBox>
  );
}
